import {
  mutationOptions,
  queryOptions,
  useMutation,
  useQuery,
  useQueryClient,
  type QueryClient,
} from '@tanstack/react-query'

import { getApi, unwrap } from '@/api/client'
import { qk } from '@/api/query-keys'
import type { RowHistorySettings, RowHistorySettingsRequest } from '@/api/types'

const PATH = '/api/database/rows/workspace/{workspace_id}/history/settings/'

export function rowHistorySettingsQuery(workspaceId: number) {
  return queryOptions({
    queryKey: qk.rowHistorySettings(workspaceId),
    queryFn: (): Promise<RowHistorySettings> =>
      unwrap(getApi().GET(PATH, { params: { path: { workspace_id: workspaceId } } })),
  })
}

export function useRowHistorySettings(workspaceId: number) {
  return useQuery(rowHistorySettingsQuery(workspaceId))
}

export function updateRowHistoryMutation(queryClient: QueryClient, workspaceId: number) {
  return mutationOptions({
    // A window longer than the plan's is refused, and the panel says so beside
    // the Save button rather than in a toast.
    meta: { skipGlobalErrorHandler: true },
    mutationFn: (body: RowHistorySettingsRequest): Promise<RowHistorySettings> =>
      unwrap(
        getApi().PATCH(PATH, { params: { path: { workspace_id: workspaceId } }, body }),
      ),
    onSuccess: (settings) => {
      queryClient.setQueryData(qk.rowHistorySettings(workspaceId), settings)
    },
  })
}

export function useUpdateRowHistory(workspaceId: number) {
  return useMutation(updateRowHistoryMutation(useQueryClient(), workspaceId))
}
